import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { ExecutionTrackerService } from 'src/app/services/execution-tracker.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NzCarouselComponent } from 'ng-zorro-antd/carousel';
import { url } from 'inspector';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.less'],
})
export class HomePageComponent implements OnInit {
  // carousel images
  carouselList: any[] = []
  canUsePortal: boolean = false;
  hasBindCustomer: boolean = false;
  effect: string = 'scrollx';

  // TO DO暂时使用，上生产需要去掉
  isHomeBak: boolean = false;
  carouselImageWH: any = {
    width: `100%`,
    height: `500px`
  }

  pagination = {
    total: 50,
    pageIndex: 1,
    pageSize: 20,
  };
  params = {
    title: '',
    description: '',
    status: 1,
    salesOrg: []
  };

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.carouselImageWH = this.carouselImageStyle()
  }

  constructor(
    public loginService: LoginService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private router: Router,
    private executionTracker: ExecutionTrackerService
  ) { }

  // component init
  ngOnInit(): void {
    const methodKey = 'homepage_tracking';
    // 确保方法只执行一次
    this.executionTracker.executeOnce(methodKey, () => {
      if (environment.production) {
        (window as any).dataLayer.push({
          event: 'dp_ow_homepage_visit',
          from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
          event_type: '',
          event_name: 'homepage visit',
          portal_name: "OfficialWebsite",
          event_content: '',
        });
      }
    });
    localStorage.removeItem('isLogout');
    this.carouselImageWH = this.carouselImageStyle()
    this.getList()
    // 登录成功，跳转到delear portal
    this.loginService.userData$.subscribe((userData: any) => {
      this.route.params.subscribe((params: any) => {
        this.isHomeBak = params?.isHomeBak === '1';
        this.canUsePortal = userData?.queryUserPageInfoResDTO?.status === 2;
      });

    });
  }
  openExternalLink(type?: number) {
    if (type === 0) {
      const country = localStorage.getItem('country');
      const token = localStorage.getItem('token');
      if (token) {
        this.router.navigate([`/${country}/ecatalog`]);
      } else {
        this.router.navigate([`/gb/cn/parts`]);
      }
      if (environment.production) {
        (window as any).dataLayer.push({
          event: 'dp_ow_homepage_click',
          from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
          event_type: 'parts',
          event_name: 'learn more',
          portal_name: "OfficialWebsite",
          event_content: '',
        });
      }
    } else if (type === 1) {
      this.router.navigate([`/gb/cn/services`]);
      if (environment.production) {
        (window as any).dataLayer.push({
          event: 'dp_ow_homepage_click',
          from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
          event_type: 'service',
          event_name: 'learn more',
          portal_name: "OfficialWebsite",
          event_content: '',
        });
      }
    } else if (type === 2) {
      window.open('https://www.boschcarservice.com.cn/', '_blank');
      if (environment.production) {
        (window as any).dataLayer.push({
          event: 'dp_ow_homepage_click',
          from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
          event_type: 'FRC',
          event_name: 'learn more',
          portal_name: "OfficialWebsite",
          event_content: '',
        });
      }
    } else {
      window.open('https://www.boschcarservice.com.cn/', '_blank');
    }

  }
  handleImageLoad(item: any) {
    this.carouselImageWH = this.carouselImageStyle();
  }

  carouselImageStyle() {
    const screenWidth = document.documentElement.clientWidth;
    const height = screenWidth / 1920 * 720
    return {
      width: `100%`,
      height: `${height}px`
    }
  }
  getList() {
    this.carouselList = [
      {
        title1: '配件、诊断及维修站服务',
        title2: '我们提供一站式服务解决方案',
        text: '',
        image: "assets/official-website/banner13.png",
        button: "Read the article",
      },
      {
        title1: '博世雨刮',
        title2: '净 · 静 · 久 · 稳',
        text: '',
        image: "assets/official-website/banner11.png",
        button: "Learn more",
      },
      {
        title1: '博世制动系统',
        title2: '始于安全，不止于安全',
        text: '',
        image: "assets/official-website/banner12.png",
        button: "Read the article",
      },
      {
        title1: '博世车联',
        title2: '百年博世，专业维修',
        text: '',
        image: "assets/official-website/banner14.png",
        needBtn: true,
        button: "了解更多",
      },
    ]
  }

  goNext(carousel: NzCarouselComponent) {
    carousel.next();
  }

  goPre(carousel: NzCarouselComponent) {
    carousel.pre();
  }

}
